import React, { useCallback } from "react";
import "./tableRecord.scss";
import TrashSVG from "../../resources/icons/trash.svg";
import Utils from "common/utils";

export default function TableRecord({
  email,
  phoneNumber,
  status,
  createdOn,
  onDelete,
  firsttime,
  disabled,
  firstName,
  lastName,
  gender,
  country,
  tenantMember = false,
}) {
  const onClick = useCallback(() => {
    if (disabled) return;
    if (email) {
      onDelete({ email });
    } else if (phoneNumber) {
      onDelete({ phoneNumber });
    }
  }, [disabled, email, phoneNumber, onDelete, status]);

  if (tenantMember) {
    const normalizedStatus = status || "Unknown";
    return (
      <div className="table-record tenant-member">
        <div className="email" title={email}>{email || "—"}</div>
        <div className="status">
          <div className={`text ${normalizedStatus.toLowerCase()}`}>
            {Utils.capitalizeFirstLetter(normalizedStatus)}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`table-record ${firsttime ? "firsttime" : "secondtime"}`}>
      <div className="email">{firstName || ""}</div>
      <div className="email ml-0">{email || ""}</div>
      <div className="email">{phoneNumber || ""}</div>
      <div className="email">{gender || ""}</div>
      <div className="email">{country || ""}</div>
      <div className="status">
        <div className={`text`}>{Utils.toDateString(createdOn)}</div>
      </div>
      <div className="status">
        <div className={`text ${status.toLowerCase()}`}>
          {Utils.capitalizeFirstLetter(status)}
        </div>
      </div>
      <div className={`delete ${disabled ? "disabled" : ""}`}>
        {/* <img src={TrashSVG} /> */}
      </div>
    </div>
  );
}
